import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PlaceholderLoaderComponent } from "./components/placeholder-loader/placeholder-loader.component";
import { LocalBreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { HasRoleDirective } from "./directives/has-role.directive";
import { BlurFormatDirective } from './directives/blur-format.directive';
import { SchedaCardComponent } from "./components/scheda-card/scheda-card.component";
import { MatDividerModule } from "@angular/material/divider";
import { RouterModule } from "@angular/router";
import { MatSidenavModule } from '@angular/material/sidenav';
import { SearchPipe } from './pipes/search.pipe';
import { DashboardChartComponent } from "./components/call-dashboard-widgets/dashboard-chart/dashboard-chart.component";
import {
    AppTrlBarChartComponent
} from "./components/call-dashboard-widgets/charts/app-trl-bar-chart/app-trl-bar-chart.component";
import {
    SsdfCallFiltersDashboardComponent
} from "./components/call-dashboard-widgets/ssdf-call-filters-dashboard/ssdf-call-filters-dashboard.component";
import {
    SsdfCallDashboardEconomicsComponent
} from "./components/call-dashboard-widgets/dashboard-views/ssdf-call-dashboard-economics/ssdf-call-dashboard-economics.component";
import {
    AppForBatchPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-for-batch-pie-chart/app-for-batch-pie-chart.component";
import {
    ValPremoneyForDayBatchCardComponent
} from "./components/call-dashboard-widgets/charts/val-premoney-for-day-batch-card/val-premoney-for-day-batch-card.component";
import {
    ValPremoneyBatchRadarChartComponent
} from "./components/call-dashboard-widgets/charts/val-premoney-batch-radar-chart/val-premoney-batch-radar-chart.component";
import {
    AppOriginationListDialogComponent
} from "./components/call-dashboard-widgets/charts/app-origination-pie-chart/app-origination-list-dialog/app-origination-list-dialog.component";
import {
    AppForRegionBarChartComponent
} from "./components/call-dashboard-widgets/charts/app-for-region-bar-chart/app-for-region-bar-chart.component";
import {
    AppForDayBatchHeatmapComponent
} from "./components/call-dashboard-widgets/charts/app-for-day-batch-heatmap/app-for-day-batch-heatmap.component";
import {
    AppRegionPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-region-pie-chart/app-region-pie-chart.component";
import {
    AppRegionBatchBarChartComponent
} from "./components/call-dashboard-widgets/charts/app-region-batch-bar-chart/app-region-batch-bar-chart.component";
import {
    SsdfCallGeneralDashboardComponent
} from "./components/call-dashboard-widgets/dashboard-areas/ssdf-call-general-dashboard/ssdf-call-general-dashboard.component";
import {
    AppBatchFundingNeedBarChartComponent
} from "./components/call-dashboard-widgets/charts/app-batch-funding-need-bar-chart/app-batch-funding-need-bar-chart.component";
import {
    SsdfCallDashboardOverviewComponent
} from "./components/call-dashboard-widgets/dashboard-views/ssdf-call-dashboard-overview/ssdf-call-dashboard-overview.component";
import {
    AppOriginationPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-origination-pie-chart/app-origination-pie-chart.component";
import {
    AppAreaPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-area-pie-chart/app-area-pie-chart.component";
import {
    ValPremoneyDayAreaChartComponent
} from "./components/call-dashboard-widgets/charts/val-premoney-day-area-chart/val-premoney-day-area-chart.component";
import {
    AppFormedCompanyPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-formed-company-pie-chart/app-formed-company-pie-chart.component";
import {
    AppFundingNeedPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-funding-need-pie-chart/app-funding-need-pie-chart.component";
import {
    AppCountryPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-country-pie-chart/app-country-pie-chart.component";
import {
    SsdfCallBatchDetailDashboardComponent
} from "./components/call-dashboard-widgets/dashboard-areas/ssdf-call-batch-detail-dashboard/ssdf-call-batch-detail-dashboard.component";
import {
    AppLabNeededPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-lab-needed-pie-chart/app-lab-needed-pie-chart.component";
import {
    AppPatentsPieChartComponent
} from "./components/call-dashboard-widgets/charts/app-patents-pie-chart/app-patents-pie-chart.component";
import {
    AppForDayBatchChartComponent
} from "./components/call-dashboard-widgets/charts/app-for-day-batch-chart/app-for-day-batch-chart.component";
import {
    ValPremoneyBatchBarChartComponent
} from "./components/call-dashboard-widgets/charts/val-premoney-batch-bar-chart/val-premoney-batch-bar-chart.component";
import {
    SsdfCallDashboardOthersComponent
} from "./components/call-dashboard-widgets/dashboard-views/ssdf-call-dashboard-others/ssdf-call-dashboard-others.component";
import {
    SsdfCallDashboardBatchComponent
} from "./components/call-dashboard-widgets/dashboard-views/ssdf-call-dashboard-batch/ssdf-call-dashboard-batch.component";
import {
    AppForDayChartComponent
} from "./components/call-dashboard-widgets/charts/app-for-day-chart/app-for-day-chart.component";
import {
    SsdfApplicationBatchChartComponent
} from './components/call-dashboard-widgets/charts/ssdf-application-batch-chart/ssdf-application-batch-chart.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSortModule } from "@angular/material/sort";
import { MatRippleModule } from "@angular/material/core";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatSidenavModule,
        RouterModule,
        MatMenuModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatIconModule,
        MatRippleModule,
        NgApexchartsModule,
        MatMenuModule,
        MatButtonToggleModule,
        MatDividerModule,
        MatTooltipModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatCheckboxModule,
        MatButtonModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatSidenavModule,
        BreadcrumbComponent,
        BreadcrumbItemDirective
    ],
    declarations:
        [PageHeaderComponent,
            PlaceholderLoaderComponent,
            LocalBreadcrumbComponent,
            HasRoleDirective,
            BlurFormatDirective,
            SchedaCardComponent, SearchPipe,
            DashboardChartComponent,
            AppForDayChartComponent,
            AppForDayBatchChartComponent,
            AppForDayBatchHeatmapComponent,
            AppForBatchPieChartComponent,
            AppFormedCompanyPieChartComponent,
            AppAreaPieChartComponent,
            AppLabNeededPieChartComponent,
            AppPatentsPieChartComponent,
            AppFundingNeedPieChartComponent,
            AppOriginationPieChartComponent,
            AppTrlBarChartComponent,
            AppBatchFundingNeedBarChartComponent,
            ValPremoneyDayAreaChartComponent,
            ValPremoneyBatchBarChartComponent,
            ValPremoneyBatchRadarChartComponent,
            ValPremoneyForDayBatchCardComponent,
            AppForRegionBarChartComponent,
            AppRegionBatchBarChartComponent,
            SsdfCallDashboardOverviewComponent,
            SsdfCallDashboardBatchComponent,
            SsdfCallDashboardEconomicsComponent,
            SsdfCallDashboardOthersComponent,
            SsdfCallGeneralDashboardComponent,
            SsdfCallFiltersDashboardComponent,
            SsdfCallBatchDetailDashboardComponent,
            AppCountryPieChartComponent,
            AppRegionPieChartComponent,
            SsdfApplicationBatchChartComponent,

            AppOriginationListDialogComponent,
        ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PageHeaderComponent,
        PlaceholderLoaderComponent,
        LocalBreadcrumbComponent,
        HasRoleDirective,
        BlurFormatDirective,
        SchedaCardComponent,
        SearchPipe,
        DashboardChartComponent,
        AppForDayChartComponent,
        AppForDayBatchChartComponent,
        AppForDayBatchHeatmapComponent,
        AppForBatchPieChartComponent,
        AppFormedCompanyPieChartComponent,
        AppAreaPieChartComponent,
        AppLabNeededPieChartComponent,
        AppPatentsPieChartComponent,
        AppFundingNeedPieChartComponent,
        AppOriginationPieChartComponent,
        AppTrlBarChartComponent,
        AppBatchFundingNeedBarChartComponent,
        ValPremoneyDayAreaChartComponent,
        ValPremoneyBatchBarChartComponent,
        ValPremoneyBatchRadarChartComponent,
        ValPremoneyForDayBatchCardComponent,
        AppForRegionBarChartComponent,
        AppRegionBatchBarChartComponent,
        SsdfCallDashboardOverviewComponent,
        SsdfCallDashboardBatchComponent,
        SsdfCallDashboardEconomicsComponent,
        SsdfCallDashboardOthersComponent,
        SsdfCallGeneralDashboardComponent,
        SsdfCallFiltersDashboardComponent,
        SsdfCallBatchDetailDashboardComponent,
        AppCountryPieChartComponent,
        AppRegionPieChartComponent,
        AppOriginationListDialogComponent,
        SsdfApplicationBatchChartComponent,
        BreadcrumbComponent,
        BreadcrumbItemDirective

    ]
})
export class SharedModule {

}
